export default "__VITE_ASSET__CVRx$yIq__"